import baseContainer from './_baseContainer';
import { initializeNavigationItems, REGISTER_NAVIGATION_VIEWS, } from '../actions/navigation';
import App from '../components/App';

const mapStateToProps = state => ({ ...state, });

const mapDispatchToProps = dispatch => ({
  registerViews: (registeredViews) => {
    dispatch({
      type: REGISTER_NAVIGATION_VIEWS,
      registeredViews,
    });
  },
  initializeNavigationItems: (state) => {
    dispatch(initializeNavigationItems(state));
  },
  dispatch,
});

export default baseContainer(mapStateToProps, mapDispatchToProps)(App);
